/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-04-01 14:53:15
 *
 *******************************************************/
// @flow

import {
  INITIAL_MULTI_LEVEL_TAGS,
  UPDATE_MANUAL_VALUES_MULTI_LEVEL_TAGS,
  INITIAL_MULTI_LEVEL_COLLECTIONS,
  UPDATE_MANUAL_VALUES_MULTI_LEVEL_COLLECTIONS
} from 'stores/flow-type/filter-tree/multi-level.type';

/**
 * call to initialize multi level tags
 */
export const initialMultiLevelTags = data => {
  return {
    type: INITIAL_MULTI_LEVEL_TAGS,
    payload: { data }
  };
};

/**
 * call to update manual values for multi level tags
 */
export const updateManualValuesMultiLevelTags = manualValues => {
  return {
    type: UPDATE_MANUAL_VALUES_MULTI_LEVEL_TAGS,
    payload: { data: manualValues }
  };
};

/**
 * call to initialize multi level tags
 */
export const initialMultiLevelCollections = data => {
  return {
    type: INITIAL_MULTI_LEVEL_COLLECTIONS,
    payload: { data }
  };
};

/**
 * call to update manual values for multi level tags
 */
export const updateManualValuesMultiLevelCollections = manualValues => {
  return {
    type: UPDATE_MANUAL_VALUES_MULTI_LEVEL_COLLECTIONS,
    payload: { data: manualValues }
  };
};
